import { DatasetName } from "./constants.ts";
import { ColumnName, FIELD_BASES, FieldName } from "./fields.ts";

export interface DatabaseFieldConfig {
  emptyFields: ColumnName[];
  fieldNameOverrides: Partial<Record<string, string>>;
}

export interface ParitaWorkspace {
  company_logo: string;
  dataset_access: DatasetName[];
  dataset_field_configs: Record<DatasetName, DatabaseFieldConfig>;
  domo_instance_domain: string;
  is_admin: boolean;
  is_current: boolean;
  name: string;
  org_name: string;
  recruitmentStageColumnNames: string[];
  customer_reports_active: boolean;
  uuid: string;
}

export interface ParitaUserInfo {
  email: string;
  first_name: string;
  id: string;
  image?: string;
  job_title?: string;
  last_name: string;
  phone_number: string;
  onboarded: boolean;
  workspaces: ParitaWorkspace[];
  permissions: Record<FieldName, ParitaPermissionRule>;
}

export interface ParitaPermissionRule {
  deny?: true;
  allow_values?: string[];
  disallow_values?: string[];
}

export function deniedFields(
  permissions: Record<FieldName, ParitaPermissionRule>,
): FieldName[] {
  const denied: FieldName[] = [];
  for (const [fieldName, rule] of Object.entries(permissions)) {
    if (rule.deny) {
      denied.push(fieldName as FieldName);
    }
  }
  return denied;
}

export function applyFieldNameOverride(
  defaultLabel: string,
  fieldName: string,
  overrides?: Partial<Record<string, string>>,
): string {
  return overrides?.[fieldName] ?? defaultLabel;
}

export function rulesForDataset(
  datasetName: DatasetName,
  permissions: Record<FieldName, ParitaPermissionRule>,
) {
  const rules = {} as Record<FieldName, ParitaPermissionRule>;
  for (const [fieldName, rule] of Object.entries(permissions)) {
    const fieldConfig = FIELD_BASES[fieldName as FieldName];
    if (
      fieldConfig &&
      (fieldConfig.datasetName as DatasetName[]).includes(datasetName)
    ) {
      rules[fieldName as FieldName] = rule;
    }
  }
  return rules;
}
